import { User as BaseUser } from '@99designs/frontend-components/components/User';
import { linkTo } from '@99designs/routing';
import * as React from 'react';

export interface Designer {
    id: string;
    displayName: string;
}

interface Props {
    user: Designer;
    size: 'extra-small' | 'small';
}

const User = ({ user, size }: Props) => (
    <BaseUser
        user={{
            name: user.displayName,
            profileUrl: `/profiles/${user.id}`,
            avatarUrl: linkTo.userAvatar(user.id, 128),
        }}
        avatarVariations={[size, 'white-border']}
        isLinked={false}
    />
);

export default User;
